import type { ComponentProps } from 'react';
import { cx } from 'classix';

import styles from './styles/Form.module.css';

type RequiredAsteriskProps = ComponentProps<'span'> & {
	'data-test-id'?: string;
};

/**
 * @deprecated use `Label` from `@launchpad-ui/components` instead
 *
 * https://launchpad.launchdarkly.com/?path=/docs/components-forms-textfield--docs
 */
const RequiredAsterisk = ({
	className,
	'data-test-id': testId = 'required-asterisk',
	...rest
}: RequiredAsteriskProps) => {
	const classes = cx(styles.requiredAsterisk, className);

	return (
		<span {...rest} data-test-id={testId} className={classes}>
			*
		</span>
	);
};

export { RequiredAsterisk };
export type { RequiredAsteriskProps };
